export default "__VITE_ASSET__DAgLMUnb__"